import { render, staticRenderFns } from "./AddToWishlistHeart.vue?vue&type=template&id=6894d53c&scoped=true&"
import script from "./AddToWishlistHeart.vue?vue&type=script&lang=ts&"
export * from "./AddToWishlistHeart.vue?vue&type=script&lang=ts&"
import style0 from "./AddToWishlistHeart.vue?vue&type=style&index=0&id=6894d53c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6894d53c",
  null
  
)

export default component.exports